import { render, staticRenderFns } from "./DiscountTrade.vue?vue&type=template&id=7649cab3&"
import script from "./DiscountTrade.vue?vue&type=script&lang=js&"
export * from "./DiscountTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports